// // frontend/src/contexts/AuthContext.js
// import React, { createContext, useState, useEffect } from 'react';

// export const AuthContext = createContext({
//   token: null,
//   role: null,
//   username: null,
//   setAuth: () => {},
// });

// export const AuthProvider = ({ children }) => {
//   const [auth, setAuth] = useState({
//     token: localStorage.getItem('token') || null,
//     role: localStorage.getItem('role') || null,
//     username: localStorage.getItem('username') || null,
//   });

//   useEffect(() => {
//     if (auth.token) {
//       localStorage.setItem('token', auth.token);
//     } else {
//       localStorage.removeItem('token');
//     }
//     if (auth.role) {
//       localStorage.setItem('role', auth.role);
//     } else {
//       localStorage.removeItem('role');
//     }
//     if (auth.username) {
//       localStorage.setItem('username', auth.username);
//     } else {
//       localStorage.removeItem('username');
//     }
//   }, [auth]);

//   return (
//     <AuthContext.Provider value={{ ...auth, setAuth }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };
import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext({
  token: null,
  role: null,
  username: null,
  year: null,
  sem: null,
  department: null,
  subjects: [],
  setAuth: () => { },
});

export const AuthProvider = ({ children }) => {
  // Safely parse subjects from localStorage
  const parseSubjects = (value) => {
    try {
      return value ? JSON.parse(value) : [];
    } catch (err) {
      console.warn('Failed to parse subjects from localStorage:', err);
      return [];
    }
  };

  const [auth, setAuth] = useState({
    token: localStorage.getItem('token') || null,
    role: localStorage.getItem('role') || null,
    username: localStorage.getItem('username') || null,
    email: localStorage.getItem('email') || null,
    year: localStorage.getItem('year') || null,
    sem: localStorage.getItem('sem') || null,
    department: localStorage.getItem('department') || null,
    subjects: parseSubjects(localStorage.getItem('subjects')),
  });


  useEffect(() => {
    if (auth.token) {
      localStorage.setItem('token', auth.token);
    } else {
      localStorage.removeItem('token');
    }

    if (auth.role) {
      localStorage.setItem('role', auth.role);
    } else {
      localStorage.removeItem('role');
    }

    if (auth.username) {
      localStorage.setItem('username', auth.username);
    } else {
      localStorage.removeItem('username');
    }

    if (auth.email) {
      localStorage.setItem('email', auth.email);
    } else {
      localStorage.removeItem('email');
    }

    if (auth.year) {
      localStorage.setItem('year', auth.year);
    } else {
      localStorage.removeItem('year');
    }

    if (auth.sem) {
      localStorage.setItem('sem', auth.sem);
    } else {
      localStorage.removeItem('sem');
    }

    if (auth.department) {
      localStorage.setItem('department', auth.department);
    } else {
      localStorage.removeItem('department');
    }

    // Always stringify subjects to prevent undefined
    localStorage.setItem('subjects', JSON.stringify(auth.subjects || []));
  }, [auth]);



  return (
    <AuthContext.Provider value={{ ...auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
